import { useContext } from "react";

import ReactJson from "react-json-view";

import { ValidatorFileContext } from "../hooks/useFile";
import { OacJsonResponse } from "../types/demo";
import { getFilteredLAJson, LAOacJsonResponse } from "../types/laOacResponse";
import { endpointStore } from "../utils/mobx/EndpointStore";

export default function JsonView() {
  const { files, selectedFileIndex } = useContext(ValidatorFileContext);
  const { endpointType } = endpointStore;
  const outputJson = files[selectedFileIndex].result as OacJsonResponse;

  // Spec과 동일시하기 위해 imageBase64 제거하여 보여줌
  const { imageBase64: _imageBase64, ...jsonWithoutImage } = outputJson;

  const filteredJson =
    endpointType === "layout-analysis"
      ? getFilteredLAJson(jsonWithoutImage as LAOacJsonResponse)
      : jsonWithoutImage;

  return (
    <div className="body w-full space-y-2 rounded-lg bg-white p-4">
      <ReactJson
        src={filteredJson}
        theme="rjv-default"
        displayDataTypes={false}
        enableClipboard={true}
        collapsed={2}
        name={false}
        style={{
          backgroundColor: "transparent",
          fontSize: "14px",
          fontFamily: "monospace",
          wordBreak: "break-all", // 긴 텍스트를 자동으로 줄바꿈
          whiteSpace: "pre-wrap", // 공백과 줄바꿈 유지하면서 자동 줄바꿈
        }}
      />
    </div>
  );
}
